define('vspot-angular/services/volunteer-service',['angular'], function (ng) {
    'use strict';

    return ['resources.Volunteer', function (Volunteer) {

        return {
            get: function (data) {
                return Volunteer.get( ng.extend( {}, data, {'selected_activity':data.activity_id} ) );
            },
            
            save: function(data) {
                return Volunteer.save( ng.extend( {}, data, {'selected_activity':data.activity_id} ) );
            },

            update: function(data) {
                return Volunteer.update( ng.extend( {}, data, {'selected_activity':data.activity_id} ) );
            },

            signWaiver: function(data) {
                return Volunteer.signWaiver( ng.extend( {}, data, {'selected_activity':data.activity_id} ) );
            },

            /**
             * confirm:
             * Tell the server it's okay to send the confirmation emails.
             *
             * @param {int} volunteerId - volunteer id for the current volunteer
             * @param {int} activityId - the activity_id used for entrance (through invitation or link)
             * @param {str} accessKey - accesskey for user - used for verification
             * check_jobs is no longer used, so that param it unneeded
             */
            confirm: function(volunteerId, activityId, accessKey) {
                return Volunteer.confirm({
                    id:                 volunteerId,
                    activity_id:        activityId,
                    selected_activity:  activityId,
                    accesskey:          accessKey
                });
            },

            decline: function(volunteerId, activityId, accessKey) {
                return Volunteer.decline({
                    id:                 volunteerId,
                    activity_id:        activityId,
                    selected_activity:  activityId,
                    accesskey:          accessKey
                });
            },

            deleteme: function(activityId) {
                return Volunteer.deleteme({
                    selected_activity:  activityId
                });
            }

        };
    }];
});

